import React, { useState } from 'react';
import { ISideNavRoute } from '../side-nav.models';
import { PagePath } from '../../navigation.enums';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { SideNavPanelRouteList } from './side-nav-panel-route-list/side-nav-panel-route-list';
import navStyles from '../../navigation.module.css';
import sideNavPanelStyles from './side-nav-panel.module.css';
import { ChevronIcon, Tooltip } from '@keplerco/core';
import { themedAssetUrl } from '../../../theme-asset-url';
import { useGlobalState } from '../../../global-state';

export function SideNavPanel(props: { learnerRoutes: ISideNavRoute[]; onOpenSettings: () => void }): JSX.Element {
  const { learnerRoutes, onOpenSettings } = props;

  const { pathname } = useLocation();

  const { value: mayViewSideNav, setValue: setMayViewSideNav } = useGlobalState('mayViewSideNav');
  const { value: sideNavVisible, setValue: setSideNavVisible } = useGlobalState('sideNavVisible');
  const { value: sideNavCollapsed, setValue: setSideNavCollapsed } = useGlobalState('sideNavCollapsed');

  return (
    <nav
      className={classNames(
        sideNavPanelStyles.sideNavPanelContainer,
        {
          [sideNavPanelStyles.visible]: mayViewSideNav && sideNavVisible,
          [sideNavPanelStyles.sideNavCollapsed]: sideNavCollapsed,
        },
      )}
    >
      <a className={sideNavPanelStyles.sideNavPanelLogoContainer} href={PagePath.roles}>
        <img
          className={classNames(
            sideNavPanelStyles.sideNavPanelLogo,
            sideNavPanelStyles.text,
            { [sideNavPanelStyles.sideNavCollapsed]: sideNavCollapsed }
          )}
          src={themedAssetUrl('logos/logo.svg')}
          alt="Logo"
        />

        <img
          className={classNames(
            sideNavPanelStyles.sideNavPanelLogo,
            sideNavPanelStyles.icon,
            { [sideNavPanelStyles.sideNavCollapsed]: sideNavCollapsed })}
          src={themedAssetUrl('logos/logo.icon.svg')}
          alt="Logo Icon"
        />
      </a>

      <button
        className={classNames(sideNavPanelStyles.sideNavPanelToggleButton, { [sideNavPanelStyles.sideNavCollapsed]: sideNavCollapsed })}
        onClick={() => setSideNavCollapsed(!sideNavCollapsed)}
      >
        <ChevronIcon tone="secondary" size={15} rotation={sideNavCollapsed ? 1 : 3} />
      </button>

      <div className={sideNavPanelStyles.sideNavPanelRoutesContainer}>

        <div className={sideNavPanelStyles.sideNavPanelLearnerRouteListContainer}>
          <SideNavPanelRouteList sideNavParentRoutes={learnerRoutes} sideNavCollapsed={sideNavCollapsed} pathname={pathname} />
        </div>
      </div>
    </nav>
  );
}
